// Pure comparison of two versions of one datasheet: box structure, and the value text typed
// into each box. Feeds DsDiffViewerModal and DSPreview's `highlight` prop.

const STRUCT_FIELDS = ['lineNo', 'sheet', 'dsZone', 'type', 'colSpan', 'label', 'labelIdx', 'fieldSource', 'fieldSourceIdx', 'order'];

// Null, undefined and '' are the same empty value; anything else compares as a string.
const norm = v => (v === null || v === undefined ? '' : String(v));

const sameStruct = (a, b) => STRUCT_FIELDS.every(f => norm(a[f]) === norm(b[f]));

const byId = boxes => new Map((boxes || []).map(b => [b.id, b]));

// boxId -> 'changed' | 'added' | 'removed'. Added = only on the right, removed = only on the left.
export function diffBoxes(leftBoxes, rightBoxes) {
  const left = byId(leftBoxes);
  const right = byId(rightBoxes);
  const out = new Map();
  left.forEach((lb, id) => {
    if (!right.has(id)) out.set(id, 'removed');
    else if (!sameStruct(lb, right.get(id))) out.set(id, 'changed');
  });
  right.forEach((_, id) => { if (!left.has(id)) out.set(id, 'added'); });
  return out;
}

const entries = m => (m instanceof Map ? [...m.entries()] : Object.entries(m || {}));

// boxId -> { left, right } for every box whose trimmed value text differs.
export function diffValues(leftValues, rightValues) {
  const l = new Map(entries(leftValues).map(([k, v]) => [String(k), v]));
  const r = new Map(entries(rightValues).map(([k, v]) => [String(k), v]));
  const out = new Map();
  new Set([...l.keys(), ...r.keys()]).forEach(id => {
    const lt = norm(l.get(id)).trim();
    const rt = norm(r.get(id)).trim();
    if (lt !== rt) out.set(id, { left: lt, right: rt });
  });
  return out;
}

// One boxId -> kind map for DSPreview. A structural kind wins; a value-only difference is 'changed'.
// Value-diff keys are strings (object keys), so they are matched back to box ids by string.
export function toHighlight(boxDiff, valueDiff) {
  const out = new Map(boxDiff || []);
  const have = new Set([...out.keys()].map(String));
  (valueDiff ? [...valueDiff.keys()] : []).forEach(id => {
    if (!have.has(String(id))) out.set(id, 'changed');
  });
  return out;
}
